/**
 * Deterministic numeric UID from a string userId.
 * Must match the server-side implementation in packages/convex/src/av/actions.ts
 * so client can map Agora UIDs back to game players.
 */
export function userIdToAgoraUid(userId: string): number {
  let hash = 5381
  for (let i = 0; i < userId.length; i++) {
    hash = ((hash << 5) + hash + userId.charCodeAt(i)) >>> 0
  }
  return hash
}
